module.exports = __webpack_public_path__ + "static/media/audible_logo.d4901de3.svg";